import { Box } from '@chakra-ui/react';
import { OrderReturnsTable } from '@/components/Templates/OrderReturns';

const OrderReturns = () => {
	return (
		<Box>
			<OrderReturnsTable />
		</Box>
	);
};

export default OrderReturns;

